export const useResponsesCardStyles = () => {
    const carouselControls = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    };
    const paginationDot = (theme) => ({
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: theme.palette.grey[500],
        transition: 'background-color 0.3s',
        '&.active': {
            backgroundColor: theme.palette.text.primary
        }
    });
    const carouselWrapper = {
        width: '100%',
        padding: '16px 0'
    };
    const navButton = (theme) => ({
        color: theme.palette.text.primary,
        border: 'transparent',
        width: '30px'
    });
    return {
        carouselControls,
        paginationDot,
        carouselWrapper,
        navButton
    };
};
